<template>
  <div class="add-funds-combined-footer">
    <h4 class="add-funds-combined-footer__title">Looking for Additional Deposit Methods?</h4>
    <span @click.prevent="onGoToWallet" class="add-funds-combined-footer__link">
      Open Your Wallet
    </span>
  </div>
</template>

<script src="./footer.js"></script>
<style src="./footer.scss" lang="scss"></style>
